var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('img',{staticStyle:{"height":"100px"},attrs:{"src":_vm.spinnerUrl,"alt":"Loading spinner"}}),(_vm.message)?_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }